var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStarIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.49173 1.19647C4.85827 0.452245 5.91939 0.452244 6.28593 1.19647L7.09932 2.84798C7.24482 3.14341 7.52645 3.34826 7.85233 3.39571L9.67452 3.66104C10.4941 3.78038 10.8217 4.78725 10.2292 5.36597L8.90801 6.65645C8.67291 6.88609 8.56565 7.21659 8.62109 7.54053L8.93262 9.36062C9.07249 10.1778 8.21437 10.8005 7.48086 10.4141L5.85492 9.5575C5.5632 9.40381 5.21446 9.40381 4.92274 9.5575L3.2968 10.4141C2.56329 10.8005 1.70517 10.1778 1.84504 9.36062L2.15657 7.54053C2.21201 7.21659 2.10475 6.88609 1.86965 6.65645L0.548477 5.36597C-0.0440065 4.78725 0.283556 3.78038 1.10314 3.66104L2.92533 3.39571C3.25121 3.34826 3.53284 3.14341 3.67834 2.84798L4.49173 1.19647Z",
    fill: "url(#paint0_linear_1889_12191)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1889_12191",
    x1: 5.38883,
    y1: -0.625,
    x2: 5.38883,
    y2: 12.6243,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFC42C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F9B402"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/starIcon.84e53894dcb08786b204a61bf808d4b5.svg";
export { ForwardRef as ReactComponent };